/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SubmittingInfo/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import IsSubmitting from './IsSubmitting/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function SubmittingInfo({
  children,
  viewPath = "/App/Widget/Content/Questions/Review/SubmittingInfo"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let selectedValueData = fromData.useDataValue({ viewPath,
context: 'selected',
})
fromData.useSetFlowToBasedOnDataIsSubmitting({ viewPath,
context: 'selected',
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'IsSubmitting'}>
<IsSubmitting
  viewPath={`${viewPath}/IsSubmitting`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}